import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { ThirdPartyFulfillmentSettingsState } from './third-party-fulfillment-settings.reducer';

const thirdPartyFulfillmentSettingsState = (state: RootState): ThirdPartyFulfillmentSettingsState =>
    state.thirdPartyFulfillmentSettings;

export const selectThirdPartyFulfillmentSettings = createSelector(
    thirdPartyFulfillmentSettingsState,
    (state) => state.data
);

export const selectThirdPartyFulfillmentSettingsFetching = createSelector(
    thirdPartyFulfillmentSettingsState,
    (state) => state.fetching
);

export const selectThirdPartyFulfillmentSettingsError = createSelector(
    thirdPartyFulfillmentSettingsState,
    (state) => state.error
);
